import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@karma-games/angular-devkit/src/lib/extended-store";
import "./store/round-history.extensions";
import { RoundHistoryRepository } from "./round-history.repository";
import { RoundHistoryState } from "./store/interfaces";
import { roundHistoryReducer } from "./store/round-history.reducers";


@NgModule({
    declarations: [],
    providers: [
        RoundHistoryRepository
    ],
    exports: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(RoundHistoryState.featureKey, roundHistoryReducer)
    ]
})
export class RoundHistoryModule {
}
